export default __webpack_public_path__ + "static/tv-show-4-62f15b9b116d892ee3d4de9db6b3aca2.jpg";